module.exports = __webpack_public_path__ + "static/media/polluter_alert.21ca919e.jpg";